<template>
  <div class="footer">
    <div class="footer_img">
      <ul class="footer_img_ul">
        <li class="footer_img_box" v-for="item in bottomImagesList" :key="item.id">
          <div class="footer_img_box_wrapper">
            <dt>
              <img
                :src="item.img"
                :alt="item.name"
              />
            </dt>
            <dd>{{item.name}}</dd>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer_list">
      <ul class="clearfix">
        <li v-for="item in records" :key="item.id" @click="getNewsDetail(item.id)">{{item.title}}</li>
      </ul>
      <p>
        Copyright © 2013 深圳市珂莱蒂尔服饰有限公司. All Rights Reserved.
        <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备13007565号</a>
      </p>
    </div>
  </div>
</template>

<script>
import { getNewsTypeList,getHomePage } from "@/api/api";
export default {
  name: "OmniFooter",
  data() {
    return {
      bottomImagesList:[],
      records: [],
    };
  },
  methods: {
    getNewsTypeList(param) {
      getNewsTypeList(param).then((res) => {
        if (res.data.code === 0) {
          this.records = res.data.data.records;
        }
      });
    },
    getNewsDetail(id) {
      this.$router.push({
        name: "News",
        query: { newsId: id },
      });
    },
    getHomePage() {
      getHomePage().then(res => {
        this.bottomImagesList = res.data.data.bottomImagesList || [];
      })
    },
  },
  mounted() {
    const param = {
      pageCurrent: 1,
      pageSize: 20,
      "qp-typeId-eq": 1,
    };
    this.getNewsTypeList(param);
    this.getHomePage()
  },
};
</script>

<style scoped>
dd, dt{
  margin: 0;
  padding: 0;
}
.footer {
  width: 100%;
  margin: 0 auto;
  padding-top: 65px;
  background-color: #141414;
  overflow: auto;
}
.footer_img {
  width: 1000px;
  margin: 0 auto;
}
.footer_img_ul{
  width: 100%;
  overflow: hidden;
  padding-bottom: 15px;
  display: flex;
}
.footer_img_ul li{
  flex: 1;
  margin-top: 20px;
}
.footer_img_ul li:nth-child(odd) div{
  display: inline-block;
  margin-right: 2%;
  text-align: center;
}
.footer_img_ul li:nth-child(even) div{
  display: inline-block;
  margin-left: 2%;
  text-align: center;
}
.footer_img_box_wrapper{
  width: 170px;
}
.footer_img_box dd{
  color: #fff;
  font-size: 14px;
  margin-top: 5px;
  text-align: center;
}
.footer_img_ul li:first-child{
  text-align: right;
}
.footer_img img {
  width: 100%;
}
.footer_list {
  width: 658px;
  margin: 0 auto 2rem auto;
  border-top: 1px solid #313131;
  padding-top: 1.5rem;
}
.footer_list ul {
  text-align: center;
}
.footer_list ul li {
  display: inline-block;
  font-size: 14px;
  width: 130px;
  text-align: center;
  cursor: pointer;
  color: #ffffff;
}
.footer_list ul li:not(:last-child) {
  border-right: 1px solid #ffffff;
}
.footer_list p {
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  margin-top: 1.5rem;
}
.footer_list p a {
  color: #ffffff;
}
</style>

